'use client';

import { useBreakpoint } from '../contexts';
import { Breakpoint } from '../enums';

interface BreakpointDisplayWrapperProps {
    minBreakpoint?: Breakpoint;
    maxBreakpoint?: Breakpoint;
    children: React.ReactNode;
}
/**
 * Only dispaly child when breakpoint is between min and max 
 * @param {Breakpoint} [props.minBreakpoint=Breakpoint.xs] - An optional param with a default value Breakpoint.xs
 * @param {Breakpoint} [props.maxBreakpoint=Breakpoint.xl] - An optional param with a default value Breakpoint.xl
 */
export const BreakpointDisplayWrapper = ({
	minBreakpoint = Breakpoint.xs,
	maxBreakpoint = Breakpoint.xl,
	children
}: BreakpointDisplayWrapperProps) => {
	const { breakpoint } = useBreakpoint();
	if (breakpoint < minBreakpoint || breakpoint > maxBreakpoint) return null;
	return children;
}